import React, { useMemo } from 'react';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import { buildUnitIdSelectGroups } from '../../utils/unitSelectUtils';

/**
 * Selector de unidad por ID (unit_id), con secciones de tasa personalizada / unidad general.
 */
const UnitIdSelect = ({
  value = '',
  onChange,
  units = [],
  product = null,
  disabled = false,
  compact = false,
  className = '',
  emptyLabel = '— Sin unidad —',
}) => {
  const { productConversionsEnabled } = useModuleSettings();

  const groups = useMemo(
    () =>
      buildUnitIdSelectGroups({
        units,
        product,
        productConversionsEnabled,
      }),
    [units, product, productConversionsEnabled],
  );

  const selectClass = compact
    ? 'w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-1 focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100'
    : 'w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100';

  const stringValue = value === '' || value == null ? '' : String(value);

  if (!groups.showGroups) {
    return (
      <select
        value={stringValue}
        onChange={(e) => onChange(e.target.value ? parseInt(e.target.value, 10) : '')}
        disabled={disabled}
        className={`${selectClass} ${className}`}
      >
        <option value="">{emptyLabel}</option>
        {groups.generalUnits.map((unit) => (
          <option key={unit.id} value={unit.id}>
            {unit.label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <select
      value={stringValue}
      onChange={(e) => onChange(e.target.value ? parseInt(e.target.value, 10) : '')}
      disabled={disabled}
      className={`${selectClass} ${className}`}
    >
      <option value="">{emptyLabel}</option>
      {groups.customUnits.length > 0 && (
        <optgroup label="Tasa personalizada">
          {groups.customUnits.map((unit) => (
            <option key={`custom-${unit.id}`} value={unit.id}>
              {unit.label}
            </option>
          ))}
        </optgroup>
      )}
      <optgroup label="Unidad general">
        {groups.generalUnits.map((unit) => (
          <option key={`general-${unit.id}`} value={unit.id}>
            {unit.label}
          </option>
        ))}
      </optgroup>
    </select>
  );
};

export default UnitIdSelect;
